import { SMALL_SCREEN_WIDTH, SMALL_SCREEN_HEIGHT } from './_constants';

export const getSmallScreenPositions = () => ({
  x: window.innerWidth - SMALL_SCREEN_WIDTH - 32,
  y: window.innerHeight - SMALL_SCREEN_HEIGHT - 32
});

export const getDevices = async (audio = true, video = true) => {
  const devices = await navigator.mediaDevices.enumerateDevices();

  let microphones: MediaDeviceInfo[] = [];
  let cameras: MediaDeviceInfo[] = [];

  if (audio) {
    microphones = devices.filter(d => d.kind === 'audioinput');
  }

  if (video) {
    cameras = devices.filter(d => d.kind === 'videoinput');
  }

  const speakers = devices.filter(d => d.kind === 'audiooutput');

  return {
    microphones,
    cameras,
    speakers
  };
};
